import { createSelector } from 'reselect';
import { TextKey, RouteName } from '@mews-commander/enums';
import { isCurrentProfileAdmin } from '@mews-commander/legacy-entities/src/selectors/session/scope';
import { getSimpleSearchResult } from './getSimpleSearchResult';

export default createSelector(isCurrentProfileAdmin, (isAdmin) => {
    const adminQueueResults = isAdmin
        ? [
              getSimpleSearchResult({
                  routeName: RouteName.ChannelManagerQueueItemIndex,
                  titleKey: TextKey.ChannelManager,
              }),
              getSimpleSearchResult({
                  routeName: RouteName.ExportQueue,
                  titleKey: TextKey.ExportPlural,
              }),
              getSimpleSearchResult({
                  routeName: RouteName.MailQueueItemIndex,
                  titleKey: TextKey.MailPlural,
              }),
              getSimpleSearchResult({
                  routeName: RouteName.InstallationQueueItemIndex,
                  titleKey: TextKey.InstallationPlural,
              }),
              getSimpleSearchResult({
                  routeName: RouteName.InventoryUpdateIndex,
                  titleKey: TextKey.InventoryUpdatePlural,
              }),
          ]
        : [];

    return [
        getSimpleSearchResult({
            routeName: RouteName.DeviceCommandIndex,
            titleKey: TextKey.DeviceCommandPlural,
        }),
        ...adminQueueResults,
    ];
});
